// removed by extract-text-webpack-plugin
module.exports = {"lightPurple":"#e2c0f9","purple":"#9800ff","small":"(min-width:600px)","medium":"(min-width:768px)","medium-large":"(min-width:1024px)","large":"(min-width:1200px)","extra-large":"(min-width:1400px)","wide":"(min-width:1600px)","easeInOutExpo":"cubic-bezier(1,0,0,1)","easeInOutQuad":"cubic-bezier(.455,.03,.515,.955)","easeOutQuad":"cubic-bezier(.25,.46,.45,.94)","content":"featured__content___2bTEm","grid":"featured__grid___3RiA5","featuredLink":"featured__featuredLink___3NUVc","imgContainer":"featured__imgContainer___3Zzq5","img":"featured__img___290n1","bgColor":"featured__bgColor___16CUv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Featured/featured.css
// module id = 158
// module chunks = 0